import { render, staticRenderFns } from "./ImageButton.vue?vue&type=template&id=3a57dbcd"
import script from "./ImageButton.vue?vue&type=script&lang=js"
export * from "./ImageButton.vue?vue&type=script&lang=js"
import style0 from "./ImageButton.vue?vue&type=style&index=0&id=3a57dbcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports